// extracted by mini-css-extract-plugin
export default {"ad":"AdSlot_ad__jnNWC"};